import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu, X } from "lucide-react";
import MonteurSidebar from "../components/MonteurSidebar";
import { useUser } from "../context/UserContext";
import { useMarketingDemoMode } from "../utils/marketingDemo";

export default function MonteurLayout() {
  const { user } = useUser();
  const marketingDemoMode = useMarketingDemoMode();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const userName = marketingDemoMode
    ? "Monteur Demo"
    : user?.naam || user?.name || user?.email || "Monteur";

  return (
    <div className="min-h-[100dvh] bg-gray-100" style={{ paddingTop: "env(safe-area-inset-top)" }}>
      <header className="sticky top-0 z-40 border-b bg-white/95 backdrop-blur">
        <div className="mx-auto flex h-14 w-full items-center justify-between px-4 lg:px-6">
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => setSidebarOpen((prev) => !prev)}
              className="inline-flex h-9 w-9 items-center justify-center rounded-md border bg-white text-gray-700 lg:hidden"
              aria-label="Menu"
            >
              {sidebarOpen ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
            </button>
            <div>
              <h1 className="text-base font-semibold text-gray-900">Monteur</h1>
            </div>
          </div>

          <div className="text-right">
            <p className="text-xs text-gray-500">Ingelogd als</p>
            <p className="text-sm font-medium text-gray-800">{userName}</p>
            {marketingDemoMode ? (
              <p className="text-[11px] font-medium text-emerald-700">Marketing-demo mode</p>
            ) : null}
          </div>
        </div>
      </header>

      <div className="mx-auto flex w-full max-w-[1600px]">
        <div className="hidden h-[calc(100dvh-3.5rem)] w-72 shrink-0 lg:block">
          <MonteurSidebar />
        </div>

        {sidebarOpen && (
          <>
            <button
              type="button"
              onClick={() => setSidebarOpen(false)}
              className="fixed inset-0 z-40 bg-black/40 lg:hidden"
              aria-label="Sluit menu"
            />
            <div className="fixed left-0 top-14 z-50 h-[calc(100dvh-3.5rem)] w-72 max-w-[85vw] lg:hidden">
              <MonteurSidebar onNavigate={() => setSidebarOpen(false)} />
            </div>
          </>
        )}

        <main className="min-w-0 flex-1 p-3 md:p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
